import { UseQueryOptions, UseQueryResult, useQuery } from "@tanstack/react-query";
import config from "../config.json";
import { IPageable, Params } from "../types/table/interfaces.type";
import { IOperator } from "./OperatorsService";
import { IProvider } from "./ProviderService";
import { RoutingPlanType } from "./RoutingPlanService";
import { createAxiosInstance } from "./ServicesHelpers";

const axiosInstance = createAxiosInstance(config.ADMIN_API_BASE_URL);

export enum InstructionType {
  TPS_ROUTE = "TPS_ROUTE",
  SUB_ROUTING = "SUB_ROUTING",
  RATED_ROUTING = "RATED_ROUTING",
  FALL_BACK_ROUTING = "FALL_BACK_ROUTING",
  SENDER_TRANSLATION = "SENDER_TRANSLATION",
  CONTENT_TRANSLATION = "CONTENT_TRANSLATION",
}

export type Instruction = {
  id: number;
  type: InstructionType;
  name: string;
  isDeleted: boolean;
  effectiveDate: string;
  operatorId: IOperator["id"];
  routingPlanId: RoutingPlanType["id"];
  providerId: IProvider["id"];
  createdBy: string;
  createdDate: string;
  timestamp: string;
  version: number;
};

export async function fetchInstructions(
  params: Params<Instruction>
): Promise<IPageable<Instruction>> {
  try {
    const response = await axiosInstance.get("/instructions", {
      params,
    });
    const data = response.data;
    return data;
  } catch (error: any) {
    console.error("Error fetching routing plan details:", error);
    throw new Error(
      error.response?.data?.message ||
        "An error occurred while getting the instructions details."
    );
  }
}

export const useInstructionsQuery = (
  params: Params<Instruction>,
  options?: UseQueryOptions<IPageable<Instruction>, Error>
): UseQueryResult<IPageable<Instruction>, Error> => {
  const queryKey = ["instructions", JSON.stringify(params)];
  return useQuery({
    queryKey,
    queryFn: () => fetchInstructions(params),
    ...options,
  });
};